import React from 'react';
export const MiniTestimonials: React.FC = () => {
  return <section className="bg-[#F5F5EB] py-10 px-5" data-id="element-149">
      <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-5 max-w-[1000px] mx-auto" data-id="element-150">
        <div className="bg-white rounded-xl p-5 shadow-[0_3px_15px_rgba(0,0,0,0.06)] flex gap-3.5 items-start" data-id="element-151">
          <div className="w-11 h-11 rounded-full flex items-center justify-center font-black font-sans text-sm text-white shrink-0 bg-brown-mid" data-id="element-152">
            JP
          </div>
          <div className="flex-1" data-id="element-153">
            <div className="text-gold-main text-sm tracking-[1px] mb-1.5" data-id="element-154">
              ★★★★★
            </div>
            <p className="text-[13px] text-[#444] font-sans italic leading-[1.5] mb-1.5" data-id="element-155">
              "El Tomo 2 me dio la ingeniería real. Levanté mis muros en 3
              semanas sin ningún error."
            </p>
            <div className="text-xs font-bold text-green-brand font-sans" data-id="element-156">
              — Juan P.
            </div>
            <div className="text-[11px] text-[#999] font-sans" data-id="element-157">
              📍 Salta, Argentina
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-5 shadow-[0_3px_15px_rgba(0,0,0,0.06)] flex gap-3.5 items-start" data-id="element-158">
          <div className="w-11 h-11 rounded-full flex items-center justify-center font-black font-sans text-sm text-white shrink-0 bg-green-mid" data-id="element-159">
            MS
          </div>
          <div className="flex-1" data-id="element-160">
            <div className="text-gold-main text-sm tracking-[1px] mb-1.5" data-id="element-161">
              ★★★★★
            </div>
            <p className="text-[13px] text-[#444] font-sans italic leading-[1.5] mb-1.5" data-id="element-162">
              "La calculadora Eco-Estimator me ahorró una fortuna. El Tomo 3 de
              acabados es pura magia."
            </p>
            <div className="text-xs font-bold text-green-brand font-sans" data-id="element-163">
              — Marina S.
            </div>
            <div className="text-[11px] text-[#999] font-sans" data-id="element-164">
              📍 Montevideo, Uruguay
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-5 shadow-[0_3px_15px_rgba(0,0,0,0.06)] flex gap-3.5 items-start" data-id="element-165">
          <div className="w-11 h-11 rounded-full flex items-center justify-center font-black font-sans text-sm text-white shrink-0 bg-brown-dark" data-id="element-166">
            RM
          </div>
          <div className="flex-1" data-id="element-167">
            <div className="text-gold-main text-sm tracking-[1px] mb-1.5" data-id="element-168">
              ★★★★★
            </div>
            <p className="text-[13px] text-[#444] font-sans italic leading-[1.5] mb-1.5" data-id="element-169">
              "La guía de legalidad fue clave. El municipio aprobó mi proyecto
              en 3 semanas."
            </p>
            <div className="text-xs font-bold text-green-brand font-sans" data-id="element-170">
              — Roberto M.
            </div>
            <div className="text-[11px] text-[#999] font-sans" data-id="element-171">
              📍 Santiago, Chile
            </div>
          </div>
        </div>
      </div>
    </section>;
};